export default __webpack_public_path__ + "static/media/two.c71d5f61.png";